import * as React from "react";

import { Block } from "../Block";
import { Button } from "../Button";
import { Image } from "../Image";
import { Card, CardBody } from "../Card";
import { ParagraphSmall, HeadingXSmall } from "../typography";

const CardOption: React.FC<TSelectable> = (props) => {
  const { value, selected, icon, title, body, onChange, ...restProps } = props;

  return (
    <Card
      selected={selected}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <CardBody
        flex={1}
        display="flex"
        flexDirection={["row", "row", "column"]}
        alignItems={["flex-start", "flex-start", "center"]}
      >
        <Image
          src={icon}
          width={["42px", "42px", "74px"]}
          height={["42px", "42px", "74px"]}
          flex="0 0 auto"
          marginBottom={[0, 0, "scale700"]}
          marginRight={["scale600", "scale600", 0]}
          strictRatio
        />
        <Block flex={1} display="flex" flexDirection="column">
          <HeadingXSmall
            color="black"
            marginTop={0}
            marginBottom={["scale600", "scale600", "scale900"]}
            center={[false, false, true]}
          >
            {title}
          </HeadingXSmall>
          <ParagraphSmall
            color="mono700"
            flex={1}
            marginTop={0}
            marginBottom={0}
            center={[false, false, true]}
          >
            {body}
          </ParagraphSmall>
          <Block
            display="flex"
            justifyContent={["flex-start", "flex-start", "center"]}
            marginTop={["scale700", "scale700", "scale900"]}
          >
            <Button
              type="button"
              kind="primary"
              size="compact"
              onClick={() => onChange?.(value)}
              disabled={selected}
              {...restProps}
            >
              {selected ? "Selected" : "Select"}
            </Button>
          </Block>
        </Block>
      </CardBody>
    </Card>
  );
};

export { CardOption };
